import Reveal from '@/components/base/Reveal';

const threeEnds = [
  { name: '消费者端', sub: '聚餐交友 / V聚', items: ['AI 找餐厅 / 套餐', '邀请 / 报名 / 支付', 'V券 / 权益 / 核销'] },
  { name: '商家端', sub: '餐厅经营工作台', items: ['菜品 / 订单 / 收银', '后厨 / 库存 / 采购', '客户 / 员工 / 结算'] },
  { name: '供应链端', sub: '供应商工作台', items: ['商品 / SPU / SKU', '库存 / 配送 / 履约', '溯源 / 结算 / 对账'] },
];

const platformLayers = [
  '用户', '商品', '订单', '权益', '库存', '支付', '结算', '数据', 'AI', '风控',
];

export default function EcosystemDiagram() {
  return (
    <section id="ecosystem" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200 text-xs md:text-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
              味聚的核心业务生态
            </div>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              一张逻辑图看懂业务协同
            </h2>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-10">
            {/* 顶层：味聚平台 */}
            <div className="flex justify-center">
              <div className="px-6 py-3 rounded-md bg-primary-500 text-background-50 font-heading font-bold text-lg md:text-xl text-center">
                味聚平台
              </div>
            </div>
            <div className="flex justify-center py-1">
              <i className="ri-arrow-down-line text-foreground-400 text-xl"></i>
            </div>

            {/* 三端 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {threeEnds.map((end) => (
                <div key={end.name} className="rounded-lg bg-background-100 border border-background-200 p-5">
                  <div className="text-center">
                    <div className="inline-flex px-4 py-1.5 rounded-full bg-accent-100 text-accent-900 text-sm font-semibold whitespace-nowrap">
                      {end.name}
                    </div>
                    <p className="mt-2 text-xs font-medium text-foreground-600 whitespace-nowrap">{end.sub}</p>
                  </div>
                  <ul className="mt-4 space-y-2">
                    {end.items.map((item) => (
                      <li key={item} className="text-center text-sm text-foreground-700 whitespace-nowrap">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="flex justify-center py-1">
              <i className="ri-arrow-down-line text-foreground-400 text-xl"></i>
            </div>

            {/* 中台 */}
            <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8">
              <div className="text-center font-heading font-bold text-lg text-foreground-950">
                味聚数字化中台
              </div>
              <div className="mt-4 flex flex-wrap justify-center gap-2">
                {platformLayers.map((layer) => (
                  <span
                    key={layer}
                    className="px-3 py-1.5 rounded-full bg-background-200 text-foreground-700 text-sm whitespace-nowrap"
                  >
                    {layer}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex justify-center py-1">
              <i className="ri-arrow-down-line text-foreground-400 text-xl"></i>
            </div>

            {/* 生态 */}
            <div className="flex justify-center">
              <div className="px-6 py-3 rounded-md bg-secondary-500 text-foreground-950 font-heading font-bold text-lg text-center">
                餐饮消费产业生态
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}